import {combineEpics, Epic} from 'redux-observable';
import {from, of} from 'rxjs';
import {switchMap, map, startWith, catchError, filter} from 'rxjs/operators';
import {isOfType} from 'typesafe-actions';

import {IState} from '../reducers';
import {
  SavedBlockAction,
  SavedBlockActionTypes,
  loadingSavedBlocks,
  loadedSavedBlocks,
  loadingSavedBlocksFailed,
  createdSavedBlock,
  creatingSavedBlockFailed,
  deletedSavedBlock,
  deletingSavedBlock,
  deletingSavedBlockFailed,
} from '../actions/savedBlockActions';
import {
  getSavedBlocks,
  createSavedBlockFromBlock,
  deleteSavedBlock,
} from '../../services/savedBlockApi';

const getSavedBlocksEpic: Epic<SavedBlockAction, SavedBlockAction, IState> = (
  action$,
  state$,
  {dispatch}
) =>
  action$.pipe(
    filter(isOfType(SavedBlockActionTypes.LOAD_SAVED_BLOCKS)),
    switchMap((action: any) =>
      from(getSavedBlocks()).pipe(
        map((response: any) => {
          return loadedSavedBlocks(response.result);
        }),
        startWith(loadingSavedBlocks()),
        catchError(() => of(loadingSavedBlocksFailed()))
      )
    )
  );
const createSavedBlockEpic: Epic<SavedBlockAction, SavedBlockAction, IState> = (
  action$,
  state$,
  {dispatch}
) =>
  action$.pipe(
    filter(isOfType(SavedBlockActionTypes.CREATE_SAVED_BLOCK)),
    switchMap((action: any) =>
      from(createSavedBlockFromBlock(action.payload)).pipe(
        map((response: any) => createdSavedBlock(response)),
        catchError(() => of(creatingSavedBlockFailed()))
      )
    )
  );

const deleteSavedBlockEpic: Epic<
  SavedBlockAction,
  SavedBlockAction,
  IState,
  any
> = (action$: any, state$: any, {dispatch}: any) =>
  action$.pipe(
    filter(isOfType(SavedBlockActionTypes.DELETE_SAVED_BLOCK)),
    switchMap((action: any) =>
      from(deleteSavedBlock(action.payload)).pipe(
        map((response: any) => {
          return deletedSavedBlock(action.payload);
        }),
        startWith(deletingSavedBlock()),
        catchError((error: any) => {
          const message = error.response?.data?.message || '';

          return of(deletingSavedBlockFailed());
        })
      )
    )
  );

export default combineEpics(
  getSavedBlocksEpic,
  createSavedBlockEpic,
  deleteSavedBlockEpic
);
